import TransferOfClaimModal from './transfer-of-claim-modal';

export default TransferOfClaimModal;
